import { useMemo } from 'react';

import { Text } from '@kanda-libs/ks-design-library';

import useJobQuoteHeader from './useJobQuoteHeader';

export interface JobQuoteHeader {
  onClick?: () => void;
  open?: boolean;
}

const JobQuoteHeader: React.FunctionComponent<JobQuoteHeader> = function ({
  onClick,
  open,
}) {
  const {
    Wrapper,
    wrapperProps,
    tradingName,
    quoteReference,
    variant,
    isLoading,
  } = useJobQuoteHeader(onClick, open);

  const quoteFromClassName = useMemo(
    () =>
      [
        'text-12-18 order-1 whitespace-nowrap',
        variant !== 'full'
          ? 'mb-auto mt-0.5 md:mt-0.75'
          : 'mb-auto mt-0.5 sm:mt-0 ',
      ].join(' '),
    [variant],
  );
  const quoteNumClassName = useMemo(
    () =>
      [
        'text-12-18 order-3 whitespace-nowrap',
        variant !== 'full' ? '' : 'sm:text-right sm:order-2 ',
      ].join(' '),
    [variant],
  );
  const tradingNameClassName = useMemo(
    () =>
      [
        'text-14-22-em md:text-16-24-em order-2',
        variant !== 'full' ? '' : 'sm:order-3',
      ].join(' '),
    [variant],
  );
  const quoteRefClassName = useMemo(
    () =>
      ['text-12-18 order-4', variant !== 'full' ? '' : 'sm:text-right'].join(
        ' ',
      ),
    [variant],
  );

  return (
    <Wrapper {...wrapperProps}>
      <Text
        className={quoteFromClassName}
        text="Quote from"
        isLoading={isLoading}
        skeletonProps={{
          width: 80,
        }}
      />
      <Text
        className={quoteNumClassName}
        text="Quote #"
        isLoading={isLoading}
        skeletonProps={{
          width: 80,
        }}
      />
      <Text
        className={tradingNameClassName}
        text={tradingName}
        isLoading={isLoading}
        skeletonProps={{
          width: 150,
        }}
      />
      <Text
        className={quoteRefClassName}
        text={quoteReference}
        isLoading={isLoading}
        skeletonProps={{
          width: 150,
        }}
      />
    </Wrapper>
  );
};

export default JobQuoteHeader;
